import { ColDef, ValueFormatterParams } from 'ag-grid-enterprise';
import { formatCurrency } from '~/lib/money';
import { AddFolderSyncOptionCell } from './OptionCell';

export type Fund = {
  id: string;
  name: string;
  jurisdictionName: string;
  inceptionDate: Date;
  terminationDate: Date;
  size: number;
  currency: string;
  handleAddFolderSync: (fundId: string) => void;
  options?: string;
};

export type FolderType = {
  id: string;
  folderName: string;
  options?: string;
  handleRemoveSync: (channelId: string) => void;
};

export const colDefsFundsTable: ColDef<Fund>[] = [
  {
    field: 'name',
    headerName: 'Fund Name',
    sortable: true,
    filter: true,
    type: 'w200',
    autoHeight: true,
    cellClass: 'flex align-items-center justify-content-left',
    wrapText: true,
    resizable: false,
    cellRenderer: 'agGroupCellRenderer',
  },
  {
    field: 'jurisdictionName',
    headerName: 'Jurisdiction',
    sortable: true,
    cellClass: 'flex align-items-center justify-content-left',
    filter: true,
    resizable: false,
  },
  {
    field: 'inceptionDate',
    headerName: 'Inception Date',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    filter: true,
    resizable: false,
  },
  {
    field: 'terminationDate',
    headerName: 'Termination Date',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    filter: true,
    resizable: false,
  },
  {
    field: 'size',
    headerName: 'Size',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    filter: true,
    resizable: false,
    valueFormatter: (p: ValueFormatterParams<Fund, number>) => {
      return typeof p.value === 'number'
        ? formatCurrency(p.data?.currency ?? 'EUR', p.value)
        : '';
    },
  },
  {
    field: 'currency',
    headerName: 'Currency',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    filter: true,
    resizable: false,
  },
  {
    field: 'options',
    headerName: '',
    cellRenderer: AddFolderSyncOptionCell,
    cellClass: 'flex align-items-center justify-content-center',
    type: 'w200',
  },
];
